import { gql } from 'graphql-tag';

export const POLYGON_FRAGMENT = gql`
    fragment POLYGON_FRAGMENT on Polygon {
        geoData {
            alias
            aliasId
            aliasIds
            areaId
            areaName
            areaStreetId
            coordinates
            countryId
            countyAreaId
            countyAreaName
            identifier
            incode
            laCode
            level
            outcode
            postTownId
            postTownName
            postalArea
            regionId
            regionName
        }
        geoType
        polygons
        radius
    }
`;
